// extracted by mini-css-extract-plugin
export default {"container":"textarea_container__+JjD1","dark":"textarea_dark__qtWoZ"};